// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f99ba9 {
  color: var(--base-text);
}
.cc1f6b {
  color: var(--base-text-disabled);
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Fields/BaseInput/components/BaseInputLabel/BaseInputLabel.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC","sourcesContent":[".f99ba9 {\n  color: var(--base-text);\n}\n.cc1f6b {\n  color: var(--base-text-disabled);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
